import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import InputMask from 'react-input-mask';
import { Modal } from 'react-bootstrap';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class LogsIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      date: null,
      modal: false,
      data_modal: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale =  getLocale();

    this.loadData = this.loadData.bind(this);
    this.findLogs = this.findLogs.bind(this);
    this.formatRequest = this.formatRequest.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/logs', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  findLogs(event) {
    event.preventDefault();
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    var datasave = {
      date: this.state.date,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/logs/buscar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'closed'}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  formatRequest (cell, row) {
    var json = JSON.parse(cell);
    json = JSON.stringify(json, null, '\t');

    return <button className="btn btn-primary" onClick={() => { this.openModal(json); }}>{this.locale.Logs.ListaLogs.verRequest}</button>;
  }

  openModal(json) {
    this.setState({modal: true, data_modal: json});
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">Logs</h3>
      <hr/>
      <form onSubmit={this.findLogs}>
        <div className="row">
          <div className="col-md-8">
            <InputMask value={this.state.date}  maskChar={null} name="name" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder="" />
          </div>
          <div className="col-md-4">
            <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.buscar}</button>
          </div>
        </div>
      </form>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Logs.ListaLogs.tabela.semTripulantesCadastrados, sizePerPage: 100, sizePerPageList: [{text: '10', value: 10}, {text: '25', value: 25}, {text: '50', value: 50}, {text: '100', value: 100}]}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar} expandComponent={ this.expandComponent } expandableRow={ this.expandableRow }>
        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='100'>{this.locale.Logs.ListaLogs.tabela.ID}</TableHeaderColumn>
        <TableHeaderColumn dataField="user" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Logs.ListaLogs.tabela.Usuario}</TableHeaderColumn>
        <TableHeaderColumn dataField="name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Logs.ListaLogs.tabela.Acao}</TableHeaderColumn>
        <TableHeaderColumn dataField="controller" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Logs.ListaLogs.tabela.Controller}</TableHeaderColumn>
        <TableHeaderColumn dataField="action" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Logs.ListaLogs.tabela.Action}</TableHeaderColumn>
        <TableHeaderColumn dataField="method" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Logs.ListaLogs.tabela.Metodo}</TableHeaderColumn>
        <TableHeaderColumn dataField="request" dataFormat={this.formatRequest} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Logs.ListaLogs.tabela.Request}</TableHeaderColumn>
        <TableHeaderColumn dataField="date" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Logs.ListaLogs.tabela.Data}</TableHeaderColumn>
      </BootstrapTable>
    </div>
  </div>
  <Modal show={this.state.modal} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">{this.locale.Logs.ListaLogs.tituloRequestDetalhado}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => { self.setState({modal: false}) }}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <pre>{this.state.data_modal}</pre>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => { self.setState({modal: false}) }}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default LogsIndex;



// WEBPACK FOOTER //
// ./src/Components/Logs/LogsIndex.js